
export interface TableData {
    transaction_code: string;
    effective_date: string;
    status: string;
    amount: string;
}


export const initDisplayedFields = [
    'transaction_code',
    'effective_date',
    'status',
    'amount'
]


